import React, { memo } from "react";
import {
  ExclamationCircleOutlined,
  DownCircleOutlined,
} from "@ant-design/icons";
import { docType } from "../../constants/DocTypeConstants";
import { IDocumnetInfoProps } from "../../interfaces/props/IDocumnetInfoProps";

import classes from "./Ui_ITOModuleCardDoc.module.css";

// UI документа
export const DocumentInfo = memo((props: IDocumnetInfoProps) => {
  const { upload, text, onClick, isActive } = props;
  const isTextOk = typeof text === "string" ? text : "";

  if (upload) {
    return (
      <div
        className={`${classes.info} ${classes.infoClickable}`}
        onClick={onClick}
      >
        <DownCircleOutlined
          className={`${classes.icon} ${classes.iconSuccess}`}
        />
        <span className={classes.text}>{isTextOk}</span>
      </div>
    );
  } else if (!upload && text) {
    return (
      <div className={classes.info}>
        <ExclamationCircleOutlined className={classes.icon} />
        <span className={`${classes.text} ${classes.textError}`}>{text}</span>
      </div>
    );
  }
  return (
    <div className={classes.info}>
      <ExclamationCircleOutlined className={classes.icon} />
      <span className={classes.text}>
        Форматы: {docType.join(", ")}. Обьем не более 20 мб.
      </span>
    </div>
  );
});

DocumentInfo.displayName = "DocumentInfo";
